import { stripTrailingSlash, setCookieTypeAndValue, setCookieDropdownValue } from '../helpers/util';
import { CookieType } from '../helpers/enums';
import { breakpoints } from '../helpers/breakpoints';

export interface CookieParams {
  reloadAfterSet: boolean;
}

export const cookie = (cookieType: CookieType, params: CookieParams = { reloadAfterSet: false }) => {
  const { reloadAfterSet } = params;

  /* Get all currency dropdown options */
  const options = document.querySelectorAll<HTMLSelectElement>(`[js-set-${cookieType}]`);

  /* Loop through each option and add an event listener */
  options.forEach((option) => {
    let optionValue: string;
    let events: string[] = [];

    if (option.tagName.toLowerCase() === 'select') {
      if (window.innerWidth < breakpoints.screen1024) {
        events = ['keypress', 'change'];
      } else {
        events = ['click'];
      }
    } else {
      events = ['click'];
    }

    events.forEach((event) =>
      option.addEventListener(event, () => {
        /* Native dropdown */
        if (option.tagName.toLowerCase() === 'select') {
          optionValue = option.value;
        } else {
          /* Custom dropdown */
          if (!option.hasAttribute('value')) {
            return;
          }
          optionValue = option.getAttribute('value')!;
        }

        /* Option has been selected, set cookie */
        setCookie(cookieType, optionValue);

        if (reloadAfterSet) {
          window.location.reload();
        }
      })
    );
  });
};

/* Create / overwrite currency cookie and then run redirect function */
const setCookie = (cookieType: CookieType, value: string) => {
  setCookieTypeAndValue(cookieType, value);
  if (cookieType === CookieType.LANGUAGE) {
    languageRedirect();
  } else {
    /* Update value of other dropdowns to match changed one (eg. currency footer to match currency navigation) */
    setCookieDropdownValue(cookieType);
  }
};

/* Redirect user depending on cookie or location */
export const languageRedirect = () => {
  const hrefLangs = window['hrefLangs'];

  if (!hrefLangs?.length) return;

  /* Default Url and remove trailing slashes */
  const enUrl = hrefLangs.find((h) => h.key === 'en-gb');

  /* Fallback to root URL when en-gb value is not available */
  const defaultUrl = stripTrailingSlash(enUrl ? enUrl!.href! : window.location.origin);

  const languageCookie = document.cookie.match(new RegExp(`(^| )${CookieType.LANGUAGE}=([^;]+)`));

  /* Language cookie exists */
  if (languageCookie) {
    /* Get url based on cookie value */
    const url = hrefLangs.find((h) => h.key === languageCookie[2].toLowerCase())?.href || defaultUrl;

    /* Remove trailing slashes */
    const formattedUrl = stripTrailingSlash(url);
    const pageUrlFormatted = stripTrailingSlash(window.location.href);

    /* New url is not current page and is not an in page anchor, redirect */
    if (formattedUrl !== pageUrlFormatted && !pageUrlFormatted.includes('anchor-id')) {
      /* Redirect */
      window.location.replace(formattedUrl);
    }
  }
};
